import logo from './logo.svg';
import './style/App.css';
import text_lang from './translations/translations';
import { useState } from 'react';
import Form from './components/Form';
import TextSubmission from './components/TextSubmission';
function App() {

  const [isSubmit, setIsSubmit] = useState(false)
  const handleSubmit =(e) =>{
    setIsSubmit(true)
  }
  return (
    <div className="App" >
              <div className='logo-space'>
  
    </div>
      {isSubmit ? <TextSubmission/> : <Form handleSubmit={handleSubmit}/>
    }
    </div>
  );
}

export default App;
